module.exports = __webpack_public_path__ + "img/mx.0f349ba.svg";